export default "__VITE_ASSET__nGdOmFGq__"